export default "__VITE_PUBLIC_ASSET__a4ad54f9__"